<template>
	<div class="sa-list-component" style="padding: 13px">
		<div class="sa-list-component-header">
			<b-row class="mb-4 align-items-center">
				<b-col cols="2" class="text-center">
					<span class="text-muted uppercase font-weight-bold">Storico Movimenti</span>
					<h2 class="h4 font-weight-bold mb-0">{{ magazzinoArticolo.nomeArticolo }}</h2>
				</b-col>
				<b-col cols="8" class="text-center">
					<DateFilterComponent @submit="onSubmitFilter" :choiseNotVisible="['P', 'M']" btnDefault />
				</b-col>
				<b-col cols="2" class="text-right" style="margin-top: 15px">
					<font-awesome-icon v-if="magazzinoArticolo.giacenze <= magazzinoArticolo.sottoscortaArticolo"
						icon="exclamation-triangle" class="text-warning" />
					<span :class="getBadgeGiacenza()">
						<strong class="font-italic">Giacenza:</strong>
						<span class="sa-badge-label" style="font-weight: 600">
							<b style="color:#007bff"> {{
								Math.ceil(magazzinoArticolo.giacenze * 100) / 100
							}}</b></span>
					</span>
				</b-col>
			</b-row>
		</div>
		<hr style="width: 80%;">
		<div class="sa-list-component-body">
			<b-container max-width="800px" style="height: 100%; overflow: auto">
				<div class="sa-articolo-timeline">
					<div v-for="(mov, index) in magazzinoArticoliMovimentazioneGiacenzaItems" :key="index"
						class="sa-articolo-timeline-item">
						<div :class="getClass(mov, 'icon')">
							<i :class="getClass(mov, 'arrow')"></i>
						</div>

						<b-card class="sa-articolo-timeline-card" :class="getClass(mov, 'cardtimeline')">
							<span class="sa-utility-value"> <i class="far fa-clock mr-1"></i> {{
								formatDate(mov.documentoData) }} </span>

							<b-row align-v="center">
								<b-col md="7">
									<h5 class="mb-1 font-weight-bold" :class="getClass(mov, 'text')">
										{{ mov.causaleDocumento }}
									</h5>
									<p class="mb-0 text-muted small">
										<span class="sa-utility-label"><i class="fas fa-file-invoice mr-1"></i>Rif:
										</span>
										<span class="sa-utility-value">
											{{ mov.tipoDocumento }} n. <b>{{ mov.documentoNumero }}</b>
										</span>
										<br />
										<span class="sa-utility-label"><i class="fas fa-building mr-1"></i>Soggetto:
										</span>
										<span class="sa-utility-value">
											{{ mov.ragioneSociale }}
										</span>
									</p>
								</b-col>

								<b-col md="5" class="text-right">
									<div class="d-flex flex-column align-items-end">
										<b-badge :class="getClass(mov, 'badge')" pill class="sa-articolo-qty-badge"> {{
											isCarico(mov) ? "+" : "" }} {{ mov.movFormato }} {{ mov.umRiga }}</b-badge>

										<span class="text-muted font-italic" style="font-size: 0.95rem">
											<strong class="font-weight-bold">Saldo Formato: </strong> <b
												style="color: #007bff">{{ mov.giacenzaFormatoDopo }}</b> <span
												class="sa-utility-value">{{ mov.umFormato }}</span>
										</span>
										<small class="text-muted font-italic" style="font-size: 90%">
											<strong class="font-weight-bold"> Saldo Base: </strong><b
												style="color: #007bff"> {{ mov.giacenzaBaseDopo }}</b>
											<span class="sa-utility-value"> {{ mov.umBase }}</span>
										</small>
									</div>
								</b-col>
							</b-row>
						</b-card>
					</div>
				</div>
				<!-- <div class="text-center mt-4">
					<b-button variant="link" class="text-muted small">Mostra movimenti precedenti...</b-button>
				</div> -->
			</b-container>
		</div>
		<div class="sa-list-component-footer" style="padding-bottom: 15px"></div>
	</div>
</template>

<script>
// import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
import DateFilterComponent from "../../utility/components/DateFilterComponent.vue";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";
// import moment from "moment";
export default {
	name: "MagazzinoArticoliStoricoMovimentazioneGiacenza",
	mixins: [UtilityMixin, MagazzinoMixins],
	components: { DateFilterComponent },
	props: {
		visibleColumns: {
			type: Array,
			required: false,
			default: () => {
				return null;
			},
		},
	},
	data() {
		return {
			currentPage: 1,
			perPage: 10,
			filtro: {},
			idArticolo: null,
			pathResource: "/contabilitadocumenti",
			pathResourceStampa: "/print/createreport",
			reportName: "documenti",
			stampaReport: null,
			rows: 0,
			fieldStorico: [
				{
					label: "Documento",
					key: "documento",
					sortable: true,
				},
				{
					label: "Codice Articolo",
					key: "articolo",
					sortable: true,
				},
				{
					label: "Prezzo Un.",
					key: "prezzoUnitario",
					sortable: true,
					formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
				},
				{
					label: "Tip. Movimento",
					key: "causaleDocumentoOperazioneMagazzino",
					sortable: true,
				},
				{
					class: "sa-table-column-action-double",
					label: "",
					key: "actions",
				},
			],
			jsonData: {},
			filter: {},
			storicoItems: [],
		};
	},
	computed: {
		fieldsColumn() {
			let me = this;
			let columns = [];
			if (!this.visibleColumns) {
				columns = this.fieldStorico;
			} else {
				columns = me.fieldStorico.filter((value) => this.visibleColumns.includes(value.key));
			}
			return columns;
		},
	},
	mounted() { },
	methods: {
		init(filtro, articolo) {
			if (filtro) {
				this.filtro = filtro;
			}
			if (articolo == null) {
				if (this.$route.params.id != null) {
					this.idArticolo = this.$route.params.id;
				}
			}
			this.loadDataArticolo();
			this.loadData();
		},
		loadDataArticolo() {
			this.magazzinoArticoloDettaglio(this.idArticolo);
		},

		loadData() {
			this.magazzinoArticoliMovimentazioneGiacenza(this.filtro);
		},
		getStyleOperazioneMagazzino(value) {
			return { color: value > 0 ? "green" : "red" };
		},
		onSubmitFilter(filter) {
			this.filtro.dataAl = filter.dataAl;
			this.filtro.dataDal = filter.dataDal;
			this.loadData();

		},
		onReset() { },
		isCarico(mov) {
			return mov.movUnitaBase > 0;
		},
		getBadgeGiacenza() {
			if (this.magazzinoArticolo) {
				if (this.magazzinoArticolo.giacenze <= this.magazzinoArticolo.sottoscortaArticolo) {
					return "sa-ft-badge-danger";
				}
				return "sa-ft-badge-success";
			}
			return null;
		},
		getClass(mov, sezione) {
			let operazione = 0;
			if (mov.movFormato == 0) {
				operazione = null;
			} else {
				operazione = mov.movFormato > 0 ? true : false;
			}

			var variabile = null;
			switch (sezione) {
				case "arrow":
					variabile = "fas fa-arrow-down";
					// 'fas fa-arrow-up' : 'fas fa-arrow-down'
					if (operazione) {
						variabile = "fas fa-arrow-up";
					}
					if (operazione == null) {
						variabile = "fas fa-plus-square";
					}
					return variabile;
				case "icon":
					//  'sa-articolo-icon-carico' : 'sa-articolo-icon-scarico'
					variabile = "sa-articolo-icon-scarico";
					if (operazione) {
						variabile = "sa-articolo-icon-carico";
					}
					if (operazione == null) {
						variabile = "sa-articolo-icon-censimento";
					}
					return "sa-articolo-timeline-icon " + variabile;
				case "cardtimeline":
					variabile = "sa-articolo-timeline-card-red";
					//  'sa-articolo-timeline-card-green' : 'sa-articolo-timeline-card-red'
					if (operazione) {
						variabile = "sa-articolo-timeline-card-green";
					}
					if (operazione == null) {
						variabile = "sa-articolo-timeline-card-censimento";
					}
					return variabile;
				case "text":
					variabile = "text-danger";
					//  'sa-articolo-timeline-card-green' : 'sa-articolo-timeline-card-red'
					if (operazione) {
						variabile = "text-success";
					}
					if (operazione == null) {
						variabile = "text-censimento";
					}
					return variabile;
				case "badge":
					variabile = "sa-ft-color-scarico";
					//  'sa-articolo-timeline-card-green' : 'sa-articolo-timeline-card-red'
					if (operazione) {
						variabile = "sa-ft-color-carico";
					}
					if (operazione == null) {
						variabile = "sa-ft-color-censimento";
					}
					return variabile;
				default:
					break;
			}
		},
	},
};
</script>
<style scoped>
.sa-utility-label {
	display: inline;
}

.sa-utility-value {
	display: inline;
}

.sa-articolo-wrapper {
	background-color: #f0f2f5;
	min-height: 100vh;
	padding: 2rem 0;
	font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Struttura Core Timeline */
.sa-articolo-timeline {
	position: relative;
	padding: 20px 0;
	list-style: none;
}

/* La linea verticale */
.sa-articolo-timeline:before {
	content: "";
	position: absolute;
	top: 0;
	bottom: 0;
	left: 40px;
	width: 2px;
	background: #dee2e6;
}

/* Singolo elemento della timeline */
.sa-articolo-timeline-item {
	position: relative;
	margin-bottom: 30px;
	padding-left: 80px;
}

/* Il cerchio sulla linea */
.sa-articolo-timeline-icon {
	position: absolute;
	left: 25px;
	top: 5px;
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: #fff;
	border: 3px solid #007bff;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
	font-size: 0.8rem;
}

.sa-ft-badge-success {
	border: 1px solid #28a745 !important;
	background-color: #28a74628;
	padding: 15px;
	margin: 10px 10px;

	border-radius: 10px;
}

.sa-ft-badge-danger {
	border: 1px solid #dc3545 !important;
	background-color: #dc35462a;
	padding: 15px;
	margin: 10px 10px;
	border-radius: 10px;
}

.sa-articolo-timeline-card-green {
	border-left: 3px solid #28a745 !important;
}

.sa-articolo-timeline-card-green:hover {
	border-top: 1px solid #28a745 !important;
	border-right: 1px solid #28a745 !important;
	border-bottom: 1px solid #28a745 !important;
}

.sa-articolo-timeline-card-red {
	border-left: 3px solid #dc3545 !important;
}

.sa-articolo-timeline-card-red:hover {
	border-top: 1px solid #dc3545 !important;
	border-right: 1px solid #dc3545 !important;
	border-bottom: 1px solid #dc3545 !important;
}

.sa-articolo-timeline-card-censimento {
	border-left: 3px solid #007bff !important;
}

.sa-articolo-timeline-card-censimento:hover {
	border-top: 1px solid #007bff !important;
	border-right: 1px solid #007bff !important;
	border-bottom: 1px solid #007bff !important;
}

.sa-articolo-icon-carico {
	border-color: #28a745;
	color: #28a745;
}

.sa-ft-color-carico {
	background-color: #28a745 !important;
}

.sa-ft-color-scarico {
	background-color: #dc3545 !important;
}

.sa-ft-color-censimento {
	background-color: #007bff !important;
}

.sa-articolo-icon-scarico {
	border-color: #dc3545;
	color: #dc3545;
}

.sa-articolo-icon-censimento {
	border-color: #007bff;
	color: #007bff;
}

.text-censimento {
	color: #007bff;
}

/* Card del movimento */
.sa-articolo-timeline-card {
	border: none;
	border-radius: 12px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	transition: transform 0.2s;
}

.sa-articolo-timeline-card:hover {
	transform: translateX(5px);
}

.sa-articolo-date-label {
	font-size: 0.8rem;
	font-weight: bold;
	color: #6c757d;
	margin-bottom: 5px;
	display: block;
}

.sa-articolo-qty-badge {
	font-size: 1rem;
	font-weight: 700;
	padding: 5px 12px;
}
</style>
